module.exports = __webpack_public_path__ + "static/media/doct2.81bcf501.webp";